'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uiBlock;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

uiBlock.$inject = ['$compile'];

function uiBlock($compile) {
    return {
        scope: {
            uiBlock: '='
        },
        restrict: 'A',
        link: function link(scope, element) {
            var overlay = getOverlay();
            var spinner = getSpinner();
            var wrapper = getWrapper([overlay, spinner]);

            var UI_BLOCKING_CLASS = 'ui-blocking';

            scope.overlayStyle = getOverlayStyle();
            scope.spinnerStyle = getSpinnerStyle();

            element.css('position', 'relative');

            if (element.find('.ui-block-wrapper').length === 0) {
                element.append($compile(wrapper)(scope));
            }

            scope.$watch('uiBlock', function () {
                if (scope.uiBlock) {
                    element.scrollTop(0); // Scroll to top while blocking the UI
                    element.addClass(UI_BLOCKING_CLASS);
                } else {
                    element.removeClass(UI_BLOCKING_CLASS);
                }
            });
        }
    };
}

function getOverlayStyle() {
    return {};
}

function getSpinnerStyle() {
    return {};
}

function getWrapper(elements) {
    var wrapper = _angular2.default.element('<div/>').attr({
        'class': 'ui-block-wrapper',
        'ng-show': 'uiBlock'
    });

    elements.forEach(function (element) {
        return wrapper.append(element);
    });

    return wrapper;
}

function getOverlay() {
    return _angular2.default.element('<div/>').attr({
        'class': 'ui-block-overlay',
        'ng-style': 'overlayStyle'
    });
}

function getSpinner() {
    return _angular2.default.element('<div><spinner></spinner></div>').attr({
        'class': 'ui-block-spinner',
        'ng-style': 'spinnerStyle'
    });
}


//////////////////
// WEBPACK FOOTER
// /app/~/angular-ui-block/lib/directives/uiBlock.js
// module id = 2582
// module chunks = 38